import React from "react";
import "./../../UaeAttestation/UaeService/UaeService.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAnglesRight } from "@fortawesome/free-solid-svg-icons";
const AustraliaBloreCertMain = () => {
  return (
    <div className="uaeServiceMainContainer">
      <ul>
        <li>
          <FontAwesomeIcon
            icon={faAnglesRight}
            className="eduCertIcon"
          ></FontAwesomeIcon>{" "}
          Apostille documents in India are issued by
          theGoodwayattestationMinistry of External Affairs
          MEAGoodwayattestation which is the branch of the Indian government
          that handles foreign affairs. MEA is a central government
          authentication that is a part of the procedure where the MEA provides
          an MEA sticker.
        </li>
        <li>
          <FontAwesomeIcon
            icon={faAnglesRight}
            className="eduCertIcon"
          ></FontAwesomeIcon>{" "}
          The procedure for theGoodwayattestationattestation of educational
          certificatesGoodwayattestation will vary depending on the origin or
          type of the document. Personal documents need validation from levels
          of government departments. Commercial documents are certified by a
          combination of governmental & non-governmental organizations.
        </li>
        <li>
          <FontAwesomeIcon
            icon={faAnglesRight}
            className="eduCertIcon"
          ></FontAwesomeIcon>{" "}
          You can get France Attestation service in Bangalore for certificates
          at Goodwayattestation which is approved by Ministries & embassies in
          India as well as abroad. We provide you best quality services & will
          complete the entire procedure of your document attestation faster.
        </li>
      </ul>
    </div>
  );
};

export default AustraliaBloreCertMain;
